var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/**
 * @Class {ScenesCollection} represents a list of scenes.
 * Each scene contains information like: path to images/videos, optional hotspots,
 * navigation between scenes and other parameters. (See IScene definition)
 * Scenes can be loaded from hardcoded data or from an external store (Redux, MobX, Singleton Service, etc).
 */
var ScenesCollection = /** @class */ (function () {
    function ScenesCollection() {
        var _this = this;
        this.findSceneBydId = function (id) {
            for (var i = 0; i < _this.scenes.length; i++) {
                if (_this.scenes[i].scene.id === id) {
                    var scene = __assign({}, _this.scenes[i]);
                    scene.scene.default_yaw = 35;
                    return _this.scenes[i];
                }
            }
        };
        this.scenes = require('./scenes.json');
    }
    ScenesCollection.prototype.getAll = function () {
        return this.scenes;
    };
    ScenesCollection.prototype.getSceneByArrayIndex = function (index) {
        var scene = __assign({}, this.scenes[index]);
        scene.scene.default_yaw = 35;
        return scene;
    };
    return ScenesCollection;
}());
export default ScenesCollection;



//////////////////
// WEBPACK FOOTER
// ./src/scenes/Scenes.ts
// module id = 238
// module chunks = 0